import { AlgoliaFinishHit } from '../../types/AlgoliaTypes';
import { useEffect, useState } from 'react';
import { getObject } from '../../services/algolia';
import { FinishCard } from '../FinishCard/FinishCard';

interface GoesWellWithProps {
    objectIDArr: string[]
}

export default function GoesWellWith({ objectIDArr }: GoesWellWithProps) {

    const [goesWellWithFinishes, setGoesWellWithFinishes] = useState<AlgoliaFinishHit[]>([]);

    const GetFinish = async (objectIDArr: string[]) => {
        objectIDArr.forEach(async element => {
            const finishItem = await getObject(element);
            setGoesWellWithFinishes([...goesWellWithFinishes, finishItem])
        });
    }

    useEffect(() => {
        GetFinish(objectIDArr);
    }, [])

    return (
        <div className={"finish-card__list"}>
            {
                goesWellWithFinishes.map((item, idx) => {

                    return (
                        <FinishCard finish={item} key={`${item.objectID}-${idx}`}/>
                    )
                })
            }
        </div>
    )
}